import React from 'react';

const LocationDisplay = ({ locationData }) => {
  // Determine what type of location data we have
  const hasAddress = locationData?.address;
  const hasCoordinates = locationData?.latitude && locationData?.longitude;
  const hasImage = locationData?.imageUrl;

  // Generate Google Maps embed URL if coordinates are available
  const googleMapsUrl = hasCoordinates ? 
    `https://maps.google.com/maps?q=${locationData.latitude},${locationData.longitude}&z=15&output=embed` 
    : null;

  if (!locationData) return null;

  return (
    <div className="tw-text-xs tw-text-gray-600 tw-bg-white tw-p-2 tw-rounded-xl border tw-border-l-4 tw-border-gray-300/70">
      <div className="tw-space-y-2">
        {locationData.addressType == "text" && hasAddress && (
          <div className="tw-flex tw-items-start tw-gap-1">
            <i className="bi bi-geo-alt tw-text-green-500 tw-mt-0.5 tw-flex-shrink-0"></i>
            <div>
              <span className="tw-font-medium tw-text-gray-700">Address:</span>
              <span className='tw-ml-2 tw-font-normal tw-text-xs tw-text-gray-600 tw-break-words'>{locationData.address}</span>
            </div>
          </div>
        )}
        
        {locationData.addressType == "location" && hasCoordinates  && (
          <div className="tw-space-y-1">
            <div className="tw-flex tw-items-center tw-gap-1">
              <i className="bi bi-crosshair tw-text-green-500"></i>
              <span className="tw-font-medium tw-text-gray-700">GPS Coordinates:</span>
            </div>
            <div className="tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-1 tw-ml-4">
              <span className="tw-flex tw-items-center tw-gap-1">
                <span className="tw-font-medium tw-text-gray-600">Latitude:</span>
                <span className="tw-text-gray-600">{locationData.latitude}</span>
              </span>
              <span className="tw-flex tw-items-center tw-gap-1">
                <span className="tw-font-medium tw-text-gray-600">Longitude:</span>
                <span className="tw-text-gray-600">{locationData.longitude}</span>
              </span>
            </div>
            
            {/* Display placeholder map during development */}
            {/* <div className="mt-3 border">
              <div className="ratio ratio-16x9" style={{ maxHeight: "250px" }}>
                <iframe
                  src={googleMapsUrl}
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Maps"
                ></iframe>
              </div>
            </div> */}
          </div>
        )}
        
        {/* {locationData.addressType == "image" && hasImage && (
          <div className="tw-space-y-1">
            <div className="tw-flex tw-items-center tw-gap-1">
              <i className="bi bi-image tw-text-green-500"></i>
              <span className="tw-font-medium tw-text-gray-700">Location Map</span>
            </div>
            <div className="tw-ml-4">
              <img 
                src={locationData.imageUrl} 
                alt="Location Map" 
                className="tw-max-w-32 tw-max-h-20 tw-object-cover tw-rounded tw-border tw-border-gray-200 tw-cursor-pointer hover:tw-opacity-80 tw-transition-opacity" 
                onClick={() => window.open(locationData.imageUrl, '_blank')}
                title="Click to view full image"
              />
            </div>
          </div>
        )} */}

        {/* {!hasAddress && !hasCoordinates && !hasImage && (
          <div className="alert alert-info mb-0">
            No location information available.
          </div>
        )} */}
      </div>
    </div>
  );
};

export default LocationDisplay;